import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('benefits_set_field_history', '/benefits_set_field_histories', 'history')
const reducer = generator.generate()

export default reducer
